/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Bwf_TitleInputs */



/**
* | output |
* | --- |
* | "BWF Metadata" |
*
* @param {Audio_Description_Export_Bwf_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_bwf_title = /** @type {((inputs?: Audio_Description_Export_Bwf_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Bwf_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Métadonnées BWF")
	if (locale === "de") return /** @type {LocalizedString} */ ("BWF-Metadaten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metadati BWF")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Метаданные BWF")
	if (locale === "es") return /** @type {LocalizedString} */ ("Metadatos BWF")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("BWF 元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("BWFメタデータ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बीडब्ल्यूएफ मेटाडेटा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Metadados BWF")
	return /** @type {LocalizedString} */ ("BWF Metadata")
});